import React from 'react'
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	Box,
	Typography,
} from '@mui/material'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import { SeasonType } from '@schemas'
import { grey, orange } from '@mui/material/colors'
import dayjs from 'dayjs'

interface PropsType {
	open: boolean
	/** 대기열에 넣으려는 시즌 */
	targetSeason: SeasonType | null
	/** 앞 순번에 있으면서 시작일이 더 늦은 시즌 중 첫 번째 */
	conflictSeason: SeasonType | null
	/** 그대로 맨 뒤에 추가 */
	onKeepOrder: () => void
	/** 시작일 기준 올바른 위치로 삽입 */
	onMoveForward: () => void
	onClose: () => void
}

/**
 * 대기열에 추가할 때 날짜 역전을 감지하면 띄운다.
 *
 * 판정: 앞 순번(E)의 START_DATE 가 새 시즌(N)의 START_DATE 보다 늦으면 역전.
 * (SEASON_OPEN_PLAN.md §7.1)
 */
export const SeasonQueueOrderWarningModal = (props: PropsType) => {
	const { open, targetSeason, conflictSeason, onKeepOrder, onMoveForward, onClose } =
		props

	const description = `${
		targetSeason?.title ?? '이 시즌'
	}이(가) 더 먼저 시작하는데 뒤 순번에 놓입니다. 순서를 앞으로 옮길까요?`

	return (
		<Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
			<DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
				<WarningAmberIcon sx={{ color: orange[700] }} />
				순서를 확인하세요
			</DialogTitle>

			<DialogContent>
				<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 2 }}>
					<Box sx={{ display: 'flex', gap: 2 }}>
						<Typography sx={{ width: '8rem', color: grey[600], flexShrink: 0 }}>
							추가하려는 시즌
						</Typography>
						<Typography sx={{ fontWeight: 600 }}>
							{targetSeason?.title}{' '}
							<Typography component="span" sx={{ color: grey[600] }}>
								{targetSeason
									? `${dayjs(targetSeason.startDate).format('YYYY-MM-DD')} 시작`
									: ''}
							</Typography>
						</Typography>
					</Box>
					<Box sx={{ display: 'flex', gap: 2 }}>
						<Typography sx={{ width: '8rem', color: grey[600], flexShrink: 0 }}>
							앞 순번
						</Typography>
						<Typography sx={{ fontWeight: 600 }}>
							{conflictSeason?.title}{' '}
							<Typography component="span" sx={{ color: grey[600] }}>
								{conflictSeason
									? `${dayjs(conflictSeason.startDate).format('YYYY-MM-DD')} 시작`
									: ''}
							</Typography>
						</Typography>
					</Box>
				</Box>

				<Typography sx={{ color: grey[700], lineHeight: 1.7 }}>{description}</Typography>
			</DialogContent>

			<DialogActions sx={{ px: 3, pb: 2 }}>
				<Button onClick={onKeepOrder} color="inherit">
					그대로 두기
				</Button>
				<Button onClick={onMoveForward} variant="contained">
					앞으로 이동
				</Button>
			</DialogActions>
		</Dialog>
	)
}
